export default {
    data() {
        return {
            imgUrl: this.imgUrl
        }
    },
    methods: {
        // 前往课程详情
        toProductDetail(id, is_project) {
            this.$toClass(id, is_project);
        },

        // 购买套餐
        buy(categoryId, productList, price) {
            // 1. 验证用户是否登录
            if (this.verifyLogin()) {
                // 没有登录, 跳转弹窗登录框
                this.$router.push({
                    path: '/personalcenter',
                });
                return;
            }

            // 2. 验证用户是否已购买该套餐
            let result = this.verifyIsBuy(categoryId);
            result.then(res => {
                // 已经购买
                if (res) {
                    this.$message.success('您已经购买了该套餐, 快去个人中心查看吧!');

                } else {
                    // 没有购买
                    let commodityList = this.getProductList(productList);
                    this.$router.push({
                        path: '/pay',
                        query: {
                            commodityList: JSON.stringify(commodityList),
                            totalprices: price,
                            categoryId: categoryId
                        }
                    });
                }
            })

        },

        // 验证用户是否登录
        verifyLogin() {
            return this.$isAbnormal(this.$store.state.id)
        },

        // 验证用户是否已经购买该套餐
        async verifyIsBuy(categoryId) {
            let res = await this.$post('orders/search_category', {
                token: this.$store.state.id,
                category_id: categoryId,
                state: 2
            });

            if (this.$isAbnormal(res.data.result)) {
                return false;
            } else {
                return true;
            }
        },

        // 取出数组中的productId, 返回productId数组
        getProductList(list) {
            return list.map(item => item.product_id);
        }

    },
    props: {
        category: Object
    },
    computed: {
        price() {
            let price = 0;
            this.category.product_category_mapping.map(item => {
                price += Number.parseFloat(item.product_price);
            });
            return price;
        }
    },
    created() {
        console.log(this.category);
    },
}